import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const isOverview = path === "/" || /^\/integrations\/?$/.test(path);
  const isDetail = !isOverview && path !== "" && path !== "/";

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md border-b border-gray-200/60 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="https://www.storyclash.com" className="flex items-center gap-2">
            <img src="/integrations/Full-Main-Dark.svg" alt="Storyclash" className="h-8" />
          </a>
          <div className="flex items-center gap-x-3">
            {isDetail && (
              <Link
                to="/"
                aria-label="Explore more integrations"
                className="inline-flex items-center justify-center px-4 py-2.5 rounded-full border border-gray-200 bg-white text-gray-900 font-semibold text-sm leading-none whitespace-nowrap text-center hover:bg-gray-50 transition"
              >
                Explore more integrations
              </Link>
            )}
            <a
              href="https://www.storyclash.com/request-demo"
              className="group relative px-5 py-2.5 rounded-full text-white font-semibold text-[15px] tracking-tight transition-all duration-300 hover:shadow-lg hover:shadow-green-500/25"
              style={{ backgroundColor: '#19B776' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#159963';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#19B776';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <span className="relative z-10">Book a Demo</span>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </a>
          </div>
        </div>
      </header>
      <div className="ad-banner fixed left-0 right-0 z-40 text-white text-center py-2 px-4 text-sm" style={{ top: '72px', backgroundColor: '#92C5F6' }}>
        <strong>Breaking news!</strong>&nbsp; Storyclash becomes part of
        <img src="/integrations/logos/KOLSQUARE-Horizontal-White-RVB.png" style={{ height: '50px', display: 'inline-block', verticalAlign: 'middle', margin: '0 8px' }} alt="Kolsquare" className="loading" />
        👉 <a href="https://www.storyclash.com/blog/en/a-new-chapter-for-storyclash-joining-forces-with-kolsquare" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline">Learn more</a>
      </div>
    </>
  );
}
